export default __webpack_public_path__ + "static/media/xiaomi_Mi_11i_phone.2c8e4876.jpg";